import { createAction } from "redux-actions";

import { SHOW_ERR_ALERT, SHOW_LOADER, SHOW_MODAL } from "./constants";

export const showErrAlert = createAction(SHOW_ERR_ALERT);
export const showModal = createAction(SHOW_MODAL);
export const showLoader = createAction(SHOW_LOADER);
